/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontLayout_viewer = {
    readonly user?: {
        readonly " $fragmentRefs": FragmentRefs<"StorefrontHead_user" | "StorefrontHome_user">;
    } | null;
    readonly seller: {
        readonly " $fragmentRefs": FragmentRefs<"StorefrontHead_seller" | "StorefrontHome_seller">;
    } | null;
    readonly products: {
        readonly " $fragmentRefs": FragmentRefs<"StorefrontHome_products">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontHead_viewer" | "StorefrontHome_viewer">;
    readonly " $refType": "StorefrontLayout_viewer";
};
export type StorefrontLayout_viewer$data = StorefrontLayout_viewer;
export type StorefrontLayout_viewer$key = {
    readonly " $data"?: StorefrontLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontLayout_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "urlLabel",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId"
        }
      ],
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "StorefrontHead_seller",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "StorefrontHome_seller",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "products",
      "name": "dealerStorefront",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "dealer",
          "variableName": "urlLabel"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 12
        },
        {
          "kind": "Literal",
          "name": "storefrontSearch",
          "value": "1"
        }
      ],
      "concreteType": "DealerStorefrontQueryConnection",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "StorefrontHome_products",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "StorefrontHead_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "StorefrontHome_user",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontHead_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontHome_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '56ec795f26bd7fc42c4a971d1272421d';
export default node;
